const Play = ({ color = '#ffffff', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M19.4733 10.9373C20.8397 11.6988 20.8447 12.6568 19.4733 13.5177L8.87627 20.6645C7.54478 21.3751 6.64046 20.9556 6.54553 19.418L6.50057 4.45982C6.47059 3.04355 7.63721 2.6434 8.74887 3.32244L19.4733 10.9373Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Play;
